export default __webpack_public_path__ + "static/help_06_05_4-0f94a62d5cb75c37e0b2a7bc5234cf5e.png";